import $ from "jquery";
let Dispatcher;

let EventEmitter;
let Metrics;
let UserStore;
let csrfSetup;
let noun_user;

csrfSetup = require("../helpers/csrf_setup").default;

EventEmitter = require("events").EventEmitter;

Dispatcher = require("../dispatcher/dispatcher").default;

Metrics = require("../helpers/metrics").default;

noun_user = require("../helpers/noun_user").default;

UserStore = (() => {
    class UserStore {
        constructor() {
            this._emitter = new EventEmitter();
            this._statuses = {
                WAITING: "WAITING",
                PROCESSING: "PROCESSING",
                SUCCESS: "SUCCESS",
                FAILURE: "FAILURE",
                COMPLETE: "COMPLETE"
            };
            this.initialize();
            this.dispatchToken = Dispatcher.register(
                (_this => payload => {
                    switch (payload.actionType) {
                        case "authenticateUser":
                            _this._currentStatus = _this._statuses.PROCESSING;
                            _this.emitEvent("change");
                            return _this.sendLoginRequest(
                                payload.url,
                                payload.formData
                            );
                        case "loginRequired":
                            _this._data.showRegister = true;
                            return _this.emitEvent("change");
                        case "setLoginRegisterState":
                            let { showRegister, showLogin } = payload;
                            _this._data.showRegister = showRegister;
                            _this._data.showLogin = showLogin;
                            return;
                        case "confirmAuth":
                            _this._currentStatus = _this._statuses.WAITING;
                            _this._errors = null;
                            _this._data.showRegister = false;
                            _this._data.showLogin = false;
                            return _this.emitEvent("change");
                        case "clearAuthErrors":
                            _this._currentStatus = _this._statuses.WAITING;
                            _this._errors = null;
                            return _this.emitEvent("change");
                        case "updateUser":
                            if (payload.updateCard) {
                                _this._data.user.has_credit_card = true;
                            }
                            _this._data.card = payload.card;
                            return _this.emitEvent("change");
                        case "subscribePayment":
                            _this.getCurrentUser();
                            _this._data.user.permissions.market = "premium";
                            if (payload.plan.indexOf("pro") === 0) {
                                _this._data.user.has_pro_account = true;
                            } else if (payload.plan.indexOf("team") === 0) {
                                _this._data.user.has_team_account = true;
                            }
                            return _this.emitEvent("change");
                    }
                })(this)
            );
        }

        initReduxDispatch(dispatch) {
            this._reduxDispatch = dispatch;
        }

        initialize() {
            this._data = {
                showLogin: null,
                showRegister: null,
                user: noun_user
            };
            this._currentStatus = this._statuses.WAITING;
            return (this._errors = null);
        }

        emitEvent(eventName, data) {
            if (data == null) {
                data = null;
            }
            if (data !== null) {
                return this._emitter.emit(eventName, data);
            } else {
                return this._emitter.emit(eventName);
            }
        }

        addListener(eventName, callback) {
            return this._emitter.on(eventName, callback);
        }

        removeListener(eventName, callback) {
            return this._emitter.removeListener(eventName, callback);
        }

        get(key) {
            return this._data[key];
        }

        getAll() {
            return this._data;
        }

        getErrors() {
            return this._errors;
        }

        getCurrentStatus() {
            return this._currentStatus;
        }

        getCurrentUser() {
            return $.get(
                "/accounts/current-user/",
                (_this => data => _this.populateUserData(data))(this)
            );
        }

        hasPremiumMarketAccess() {
            return this._data.user.permissions.market === "premium";
        }

        isLoggedIn() {
            return !this._data.user.is_anonymous;
        }

        shouldSeeAds() {
            if (!this.isLoggedIn()) {
                return true;
            }
            if (!this.hasPremiumMarketAccess()) {
                return true;
            }
        }

        populateUserData(data) {
            noun_user = data.user;
            this._data.user = data.user;
            this._data.showLogin = false;
            this._data.showRegister = false;
            this._currentStatus = this._statuses.SUCCESS;
            //Update CSRF token for all subsequent AJAX requests
            csrfSetup();
            this.emitEvent("change");

            if (this._reduxDispatch) {
                this._reduxDispatch({
                    type: "GET_CURRENT_USER_SUCCESS",
                    response: data.user
                });
            }

            return Dispatcher.dispatch({
                actionType: "userUpdated"
            });
        }

        sendLoginRequest(url, formData) {
            return $.post(url, formData)
                .done(
                    (_this => data => {
                        if (url === "/accounts/signup/") {
                            new Metrics().signup_complete();
                        }
                        return _this.getCurrentUser();
                    })(this)
                )
                .fail(
                    (_this => (xhr, status, error) => {
                        let err;
                        let errors;
                        let key;
                        let ref;
                        _this._currentStatus = _this._statuses.FAILURE;
                        if (xhr.status === 400) {
                            errors = {};
                            ref = xhr.responseJSON.form_errors;
                            for (key in ref) {
                                err = ref[key];
                                if (key === "__all__") {
                                    errors.userId = err[0];
                                } else {
                                    errors[key] = err;
                                }
                            }
                            _this._errors = errors;
                        }
                        return _this.emitEvent("change");
                    })(this)
                );
        }
    }

    return UserStore;
})();

const UserStoreInstance = new UserStore();
global.UserStore = UserStoreInstance;
export default UserStoreInstance;
